import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-business-unit-employee-navigation',
  templateUrl: './business-unit-employee-navigation.component.html',
  styleUrls: ['./business-unit-employee-navigation.component.scss']
})
export class BusinessUnitEmployeeNavigationComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
